function getVitalsObject(noteOrContent) {
  const content = noteOrContent?.openaiNote || noteOrContent?.note_content || noteOrContent || {};
  return content.vitals || content.vitals_extracted || {};
}

function hasValue(value) {
  return value != null && value !== '';
}

function o2Display(value) {
  return String(value ?? '')
    .replace(/%+\s*$/g, '')
    .trim();
}

function getLabels(language = 'en') {
  if (language === 'ar') {
    return {
      bp: 'ضغط الدم',
      pulse: 'النبض',
      temp: 'الحرارة',
      o2: 'الأكسجين',
      rr: 'التنفس',
      pain: 'الألم',
      weight: 'الوزن',
      bloodSugar: 'سكر الدم',
      recorded: 'علامات حيوية مسجلة',
    };
  }
  return {
    bp: 'BP',
    pulse: 'Pulse',
    temp: 'Temp',
    o2: 'O₂',
    rr: 'RR',
    pain: 'Pain',
    weight: 'Weight',
    bloodSugar: 'Blood sugar',
    recorded: 'Vitals recorded',
  };
}

export function formatVitalsSummary(noteOrContent, language = 'en') {
  const v = getVitalsObject(noteOrContent);
  const labels = getLabels(language);
  const parts = [];

  if (hasValue(v.bp_systolic) || hasValue(v.bp_diastolic)) {
    const sys = v.bp_systolic ?? '—';
    const dia = v.bp_diastolic ?? '—';
    parts.push(`${labels.bp} ${sys}/${dia}`);
  } else if (hasValue(v.bp)) {
    parts.push(`${labels.bp} ${v.bp}`);
  }

  if (hasValue(v.pulse)) parts.push(`${labels.pulse} ${v.pulse}`);
  if (hasValue(v.temp_celsius)) parts.push(`${labels.temp} ${v.temp_celsius}°C`);
  if (hasValue(v.o2_sat)) parts.push(`${labels.o2} ${o2Display(v.o2_sat)}%`);
  if (hasValue(v.rr)) parts.push(`${labels.rr} ${v.rr}`);
  if (hasValue(v.pain)) parts.push(`${labels.pain} ${v.pain}/10`);
  if (hasValue(v.weight_kg)) parts.push(`${labels.weight} ${v.weight_kg} kg`);
  if (hasValue(v.blood_sugar)) parts.push(`${labels.bloodSugar} ${v.blood_sugar}`);

  return parts.join(' · ');
}

export function formatVitalsLabels(noteOrContent, language = 'en') {
  const v = getVitalsObject(noteOrContent);
  const labels = getLabels(language);
  const parts = [];

  if (hasValue(v.bp_systolic) || hasValue(v.bp_diastolic) || hasValue(v.bp)) parts.push(labels.bp);
  if (hasValue(v.pulse)) parts.push(labels.pulse);
  if (hasValue(v.temp_celsius)) parts.push(labels.temp);
  if (hasValue(v.o2_sat)) parts.push(labels.o2);
  if (hasValue(v.rr)) parts.push(labels.rr);
  if (hasValue(v.pain)) parts.push(labels.pain);
  if (hasValue(v.weight_kg)) parts.push(labels.weight);
  if (hasValue(v.blood_sugar)) parts.push(labels.bloodSugar);

  return parts.join(', ');
}

export function formatVitalsListSummary(noteOrContent, language = 'en') {
  const labels = getLabels(language);
  return (
    formatVitalsSummary(noteOrContent, language)
    || formatVitalsLabels(noteOrContent, language)
    || labels.recorded
  );
}
